(function () {
    window.gbg = window.gbg || {};
}());
(function () {
    'use strict';
    gbg.GlobalItemsList = (function () {
        //console.log('GlobalItemsList')

        var collections = [];

        const globalItemsContainers = document.querySelectorAll('.global-items-list');
        //const ddlFilters = document.querySelectorAll('.global-items-list .pseudoDdlOptions input[type=checkbox]');
        const ddlFilters = document.querySelectorAll('.pseudoDdlOptions input[type=checkbox]');
        const pseudoDdls = document.querySelectorAll('.pseudoDdl');
        const pseudoDdlsClose = document.querySelectorAll('.pseudoDdlClose');
        const searchBoxes = document.querySelectorAll('.global-items-search');
        const searchForms = document.querySelectorAll('.global-items-search__form');
        const pageurl = new URL(window.location);
        var isPop = false;
        var allFilterName = '';


        var init = function (itemsPerPage) {
            //console.log('GlobalItemsListInit')
            setUpSearchBox();
            setUpSearchForm();
            setUpPseudoDdls();
            setUpArrays(itemsPerPage);
            setUpFilterLists();
            checkLoadMoreVisibility();
            checkUrlPresets();
            window.addEventListener('popstate', function (event) {
                gbg.GlobalItemsList.popstateReload();
            });
        };

        //set up the first search box on the page, update container keywords supplied by query string
        //also add the search function on key up with a timeout in a debounce way so it doesn't trigger constantly
        //handle enter key press to jump down the page if needed
        var setUpSearchBox = function () {
            if (searchBoxes.length > 0) {
                //search box present - should only be one per page
                var searchBox = searchBoxes[0];
                //get any keyword passed through the URL
                var urlParams = new URLSearchParams(window.location.search);
                var keywords = urlParams.get('k');
                if (keywords !== '' && keywords !== null && keywords !== 'null') {
                    searchBox.value = keywords;
                    if (searchBox.hasAttribute('data-updateAllLists') && searchBox.dataset.updatealllists === 'true') {
                        for (var i = 0; i < globalItemsContainers.length; i++) {
                            globalItemsContainers[i].dataset.keywords = keywords;//setAttribute('data', 'keywords:' + keywords);
                        }
                    }
                }
                searchBox.addEventListener('keyup', function (e) {
                    clearTimeout(searchBoxTimer);
                    searchValue = this.value;
                    if (this.hasAttribute('data-updateAllLists') || this.hasAttribute('data-updatealllists') && (this.dataset.updateAllLists === 'true' || this.dataset.updatealllists === 'true')) {
                        searchBoxTimer = setTimeout(function () {
                            var alterPopState = true;
                            for (var i = 0; i < globalItemsContainers.length; i++) {
                                //update each list with the new keyword search value
                                //globalItemsContainers[i].keywords = this.value;
                                var list = globalItemsContainers[i].dataset.list;
                                if (list === 'none') return;
                                clearArray(list, 'keywords');
                                addToArray(list, 'keywords', searchValue);
                                gbg.GlobalItemsList.resetPaging(list);
                                gbg.GlobalItemsList.setUpReload(list, alterPopState);
                                alterPopState = false;
                            }
                            //gbg.GlobalItemsList.scrollToFirstList();
                            gbg.GlobalItemsList.searchEvent(searchValue);
                        }, 500);
                    }
                    if (e.key === 'Enter' || e.keyCode === 13) {
                        //gbg.GlobalItemsList.searchEvent(searchValue);
                        gbg.GlobalItemsList.scrollToFirstList();
                    }
                });
            }
        };

        //set up the search box form submit events to log the search or scroll to the first list
        var setUpSearchForm = function () {
            if (searchForms.length > 0) {
                
                var searchForm = searchForms[0];
                var searchBox = searchForm.querySelector('.global-items-search');

                if (searchBox.hasAttribute('data-updateAllLists') && searchBox.dataset.updatealllists !== 'true') {
                    searchForm.addEventListener('submit', function (e) {
                        if (e.preventDefault) e.preventDefault();
                        var input = this.querySelector('.global-items-search');
                        var searchValue = input ? input.value : '';
                        if (this.dataset.updateAllLists !== 'true') {
                            searchEvent(searchValue);
                        }
                        this.submit();
                        return true;
                    });
                } else {
                    searchForm.addEventListener('submit', function (e) {
                        if (e.preventDefault) e.preventDefault();
                        gbg.GlobalItemsList.scrollToFirstList();
                        return false;
                    });
                }
                
            }
        };

        //set up click events for drop down filters
        var setUpPseudoDdls = function () {
            for (var i = 0; i < pseudoDdls.length; i++) {
                pseudoDdls[i].addEventListener('click', function () {
                    //var width = this.offsetWidth + 'px';
                    //var options = this.parentNode.querySelector('.pseudoDdlOptions');
                    //options.style.width = width;
                    //options.attr('min-width', width);
                    //options.attr('max-width', width);
                    //close any open filter menu
                    //if (this.id !== '' && this.id.startsWith('ddlFilterAll')) {
                        var openFilter = document.querySelector('.pseudoDdl.pseudoDdl--open');
                        if (openFilter && openFilter.id !== this.id) openFilter.classList.remove('pseudoDdl--open');
                    //}
                    this.classList.toggle('pseudoDdl--open');
                });
            }
            for (i = 0; i < pseudoDdlsClose.length; i++) {
                pseudoDdlsClose[i].addEventListener('click', function () { this.parentNode.querySelector('.pseudoDdl').classList.toggle('pseudoDdl--open'); });
            }
        };

        //set up the array containers for all lists on a page to hold all the variables that determine what they display
        var setUpArrays = function () {
            for (var i = 0; i < globalItemsContainers.length; i++) {
                //check fixed types
                var arrTypes = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedtype")) arrTypes = [globalItemsContainers[i].dataset.fixedtype];
                //check items
                var items = 9;
                if (globalItemsContainers[i].hasAttribute("data-itemsperpage")) items = globalItemsContainers[i].dataset.itemsperpage;
                //check excluded items
                var exclusions = '';
                if (globalItemsContainers[i].hasAttribute("data-exclusions")) exclusions = globalItemsContainers[i].dataset.exclusions;
                //check sectors
                var sectors = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedsector")) sectors = [globalItemsContainers[i].dataset.fixedsector];
                //check products
                var products = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedproduct")) products = [globalItemsContainers[i].dataset.fixedproduct];
                //check product
                var product = [];
                if (globalItemsContainers[i].hasAttribute("data-product")) product = [globalItemsContainers[i].dataset.product];
                //check regions
                var regions = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedregion")) types = [globalItemsContainers[i].dataset.fixedregion];
                //check tags
                var tags = [];
                if (globalItemsContainers[i].hasAttribute("data-tag")) tags = [globalItemsContainers[i].dataset.tag];
                //check fixed tags
                var fixedtags = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedtag")) fixedtags = [globalItemsContainers[i].dataset.fixedtag];
                //check keywords
                var keywords = [];
                if (globalItemsContainers[i].hasAttribute("data-keywords")) keywords = [globalItemsContainers[i].dataset.keywords];
                //check category
                var category = [];
                if (globalItemsContainers[i].hasAttribute("data-category")) category = [globalItemsContainers[i].dataset.category];
                //check subcategory
                var subcategory = [];
                if (globalItemsContainers[i].hasAttribute("data-subcategory")) subcategory = [globalItemsContainers[i].dataset.subcategory];
                //check apac products
                var apacproducts = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedapacproduct")) apacproducts = [globalItemsContainers[i].dataset.fixedapacproduct];
                //check apac topics
                var apactopics = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedapactopic")) apactopics = [globalItemsContainers[i].dataset.fixedapactopic];
                //check apac user roles
                var apacuserroles = [];
                if (globalItemsContainers[i].hasAttribute("data-fixedapacuserrole")) apacuserroles = [globalItemsContainers[i].dataset.fixedapacuserrole];
                //check topics
                var topics = [];
                if (globalItemsContainers[i].hasAttribute("data-topics")) topics = [globalItemsContainers[i].dataset.topics];
                var data = { list: globalItemsContainers[i].dataset.list, action: globalItemsContainers[i].dataset.action, sectors: sectors, regions: regions, products: products, product: product, apacproducts: apacproducts, apactopics: apactopics, apacuserroles: apacuserroles, types: arrTypes, tags: tags, fixedtags: fixedtags, category: category, subcategory: subcategory, keywords: keywords, currentPage: 1, itemsPerPage: items, exclusions: exclusions, topics:topics };
                collections.push(data);
            }
        };

        //add click event for drop down lists
        var setUpFilterLists = function () {

            var ignorePopUpdate = false;
            for (var i = 0; i < ddlFilters.length; i++) {

                ddlFilters[i].addEventListener('click', function () {

                    var parent = this.parentElement;
                    if ("list" in parent.dataset) {
                        if (parent.dataset.list.startsWith('All')) {
                            allFilterName = parent.dataset.list;
                            for (var i = 0; i < globalItemsContainers.length; i++) {
                                //update each list with the new selected value
                                var list = globalItemsContainers[i].dataset.list;
                                filterListClick(this, parent, list, ignorePopUpdate);
                                if (!list.startsWith('All')) ignorePopUpdate = true;
                            }
                        }
                        else {
                            allFilterName = '';
                            filterListClick(this, this.parentElement, parent.dataset.list);
                        }
                    }

                });

            }

        };

        //click event code for drop down lists
        var filterListClick = function (elmnt, parent, list, ignorePopUpdate) {

            gbg.GlobalItemsList.resetPaging(list);
            if (elmnt.dataset.filtervalue === 'all') {
                gbg.GlobalItemsList.clearArray(list, parent.dataset.filtertype);
                gbg.GlobalItemsList.clearNonAllOptions(list, parent.dataset.filtertype);
            } else {
                if (elmnt.checked) {
                    gbg.GlobalItemsList.addToArray(list, parent.dataset.filtertype, elmnt.dataset.filtervalue);
                } else {
                    gbg.GlobalItemsList.removeFromArray(list, parent.dataset.filtertype, elmnt.dataset.filtervalue);
                }
                gbg.GlobalItemsList.checkForAll(list, parent.dataset.filtertype);
            }
            gbg.GlobalItemsList.setUpReload(list, ignorePopUpdate);
            gbg.GlobalItemsList.updateFiltersSelected(list);

            var openDdl = document.querySelector('.pseudoDdl.pseudoDdl--open');
            if (openDdl) openDdl.classList.remove('pseudoDdl--open');
            if (document.getElementById('ddlFilter' + list)) document.getElementById('ddlFilter' + list).classList.remove('pseudoDdl--open');

        };

        //Clear link - need to reset selected options in all dropdowns
        //var clearAllFilters = function () {
        //    collections = [];
        //    gbg.GlobalItemsList.setUpArrays();
        //};

        //load more links are hidden by default - this function checks whether they should be shown
        var checkLoadMoreVisibility = function () {
            //console.log('checkLoadMoreVisibility');
            var lsts = document.querySelectorAll('.filterable-list');
            for (var i = 0; i < lsts.length; i++) {
                if (!lsts[i].innerHTML.trim().endsWith('<!--END-->')) {
                    var parent = lsts[i].parentNode;
                    var loadMoreLink = document.getElementById('loadMore' + parent.dataset.list);
                    if (loadMoreLink) loadMoreLink.style.display = '';
                }
            }
        };

        //reload the page on a dynamic popstate
        var popstateReload = function () {
            isPop = true;
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams === null) {
                setUpFilterLists();
            } else {
                checkUrlPresets();
            }
        };

        //grab query string values and update any lists and drop downs accordingly on page load
        var checkUrlPresets = function () {
            var urlParams = new URLSearchParams(window.location.search);
            var list = urlParams.get('l'),
                p = urlParams.get('p'),
                pr = urlParams.get('pr'),
                i = urlParams.get('i'),
                s = urlParams.get('s'),
                r = urlParams.get('r'),
                a = urlParams.get('a'),
                t = urlParams.get('t'),
                e = urlParams.get('e'),
                sr = urlParams.get('sr'),
                tag = urlParams.get('tag'),
                keywords = urlParams.get('k'),
                ap = urlParams.get('ap'),
                at = urlParams.get('at'),
                aur = urlParams.get('aur'),
                tp = urlParams.get('tp');
            if (keywords !== null && list === null) {
                list = 'All';
                p = 1;
            }
            if (list !== null) {
                if (list.startsWith('All')) allFilterName = list;
                var pg = parseInt(p, 10);
                if (pg > 0) {

                    var indx = collections.findIndex(x => x.list.startsWith(list));

                    //update all collection values if affecting all lists
                    if (allFilterName !== '') {
                        for (var z = 0; z < collections.length; z++) {
                            updateCollectionsFromQueryString(z, s, r, a, pr, t,tag, keywords, ap, at, aur,tp);
                        }
                    } else {
                        updateCollectionsFromQueryString(indx, s, r, a, pr, t, tag, keywords, ap, at, aur,tp);
                    }

                    var listToUse = collections[indx].list;
                    updateFiltersSelected(listToUse);

                    var replace = true;
                    var ignorePop = false;

                    if (listToUse.startsWith('All')) {

                        for (var container = 0; container < globalItemsContainers.length; container++) {

                            listToUse = globalItemsContainers[container].dataset.list;
                            if (listToUse === 'none') return;
                            if (listToUse.startsWith('All')) continue;
                            gbg.GlobalItemsList.resetPaging(listToUse);
                            replace = true;
                            var lstHtml = document.querySelector('#globalItemsContainer' + listToUse + ' .filterable-list');

                            for (var num = 1; num <= pg; num++) {
                                ignorePop = !listToUse.startsWith('All') && num !== pg;
                                if (lstHtml.innerHTML.indexOf('<!--END-->') > 0) continue;
                                loadContent(listToUse, replace, pg, ignorePop);
                                replace = false;
                            }

                        }

                    } else {
                        gbg.GlobalItemsList.resetPaging(listToUse);
                        for (var x = 1; x <= pg; x++) {
                            ignorePop = x !== pg;
                            loadContent(listToUse, replace, pg, ignorePop);
                            replace = false;
                        }
                    }
                }
                if (keywords !== null) scrollToFirstList();
            }
        };

        //common function used above
        var querystringToArray = function (list, arr, queryvalue) {
            if (queryvalue === null) return;
            var splitChar = ',';
            if (queryvalue.indexOf('|') > -1) splitChar = '|';
            var tmp = queryvalue.split(splitChar);
            for (var a = 0; a < tmp.length; a++) {
                addToArray(list, arr, tmp[a]);
            }
        };

        //ditto
        var updateCollectionsFromQueryString = function (indx, s, r, a, pr, t, tag, keywords, ap, at, aur,tp) {
            var listToUse = collections[indx].list;
            //set presets in appropriate filter list
            collections[indx]['sectors'] = [];
            collections[indx]['regions'] = [];
            collections[indx]['products'] = [];
            collections[indx]['product'] = [];
            collections[indx]['types'] = [];
            collections[indx]['tags'] = [];
            collections[indx]['keywords'] = [];
            collections[indx]['apacproducts'] = [];
            collections[indx]['apactopics'] = [];
            collections[indx]['apacuserroles'] = [];
            collections[indx]['topics'] = [];

            querystringToArray(listToUse, 'sectors', s);
            querystringToArray(listToUse, 'regions', r);
            querystringToArray(listToUse, 'products', a);
            querystringToArray(listToUse, 'product', pr);
            querystringToArray(listToUse, 'types', t);
            querystringToArray(listToUse, 'tags', tag);
            querystringToArray(listToUse, 'keywords', keywords);
            querystringToArray(listToUse, 'apacproducts', ap);
            querystringToArray(listToUse, 'apactopics', at);
            querystringToArray(listToUse, 'apacuserroles', aur);
            querystringToArray(listToUse, 'topics', tp);
            
        };

        //makes the call to dynamically load content based on the list ID
        var loadContent = function (list, replace, lastPageNumberForSequence, ignorePopUpdate) {
            //console.log('loadContent: ' + list + ', ' + replace + ', ' + lastPageNumberForSequence + ', ' + ignorePopUpdate);
            ////get the form action URL to post to
            //var parentForm = document.getElementById('formFilters' + list);
            //var url = parentForm.dataset.action;

            //get the right collection
            var indx = collections.findIndex(x => x.list === list);

            //increase the page number each time - don't do it before calling loadCOntent
            collections[indx].currentPage += 1;
            //get the arrays
            var collection = collections[indx];

            var url = collection.action;
            if (url === '' || url === null || url === undefined) return;

            //get the current site region
            var sr = 'en';
            if (currentRegion && currentRegion !== '') sr = currentRegion;

            //hide load more option
            var loadMoreLink = document.getElementById('loadMore' + list);
            if (loadMoreLink) loadMoreLink.style.display = 'none';

            //lastPageNumberForSequencei
            //to stop results coming back in the wrong order and the load more link being made visible even though the last page has been fetched
            //used when there are query string values with a page number
            //can alter load more visibility if no last page number passed in here, or this is the last page in the sequence being requested
            var canSetLoadMoreStatus = lastPageNumberForSequence === undefined || (lastPageNumberForSequence !== null && collection.currentPage === lastPageNumberForSequence);
            
            var lst = document.querySelector('#globalItemsContainer' + list + ' .filterable-list');
            if (replace) 
                lst.innerHTML = '';

            var xhttp = new XMLHttpRequest();
            xhttp.open('GET', '/umbraco/surface' + url + '/?p=' + collection.currentPage + '&i=' + collection.itemsPerPage + '&s=' + collection.sectors.join('|') + '&r=' + collection.regions.join('|') + '&a=' + collection.products.join('|') + '&t=' + collection.types.join('|') + '&c=' + collection.category.join('|') + '&sc=' + collection.subcategory.join('|') + '&ap=' + collection.apacproducts.join('|') + '&at=' + collection.apactopics.join('|') + '&aur=' + collection.apacuserroles.join('|') + '&tag=' + collection.tags.join('|') + '&tagf=' + collection.fixedtags.join('|') + '&k=' + collection.keywords.join('|') + '&pr=' + collection.product/*.join('|')*/ + '&e=' + collection.exclusions + '&sr=' + sr + '&tp=' + collection.topics.join('|'), true);
            xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhttp.onreadystatechange = function () {

                if (this.readyState === 4 && this.status === 200) {

                    // Response
                    var response = this.responseText;
                    if (replace) {
                        //lst.innerHTML = '';
                        lst.innerHTML = response;
                    } else {
                        lst.innerHTML += response;
                    }

                    if (canSetLoadMoreStatus && !response.trim().endsWith('!--END-->')) document.getElementById('loadMore' + list).style.display = '';

                    if (replace) setTimeout(function () { document.querySelector('#globalItemsContainer' + list + ' .filterable-list').classList.add('show'); }, 100);

                    if (list.startsWith('faqs')) gbg.Accordions.displayAccordions();

                    optanonRefresher();

                } else {
                    if (replace) document.querySelector('#globalItemsContainer' + list + ' .filterable-list').classList.add('show');
                }
            };
            xhttp.send();

            if (ignorePopUpdate) return;
            //update the page URL with things that have changed where applicable
            if (history.pushState && !isPop) {
                var listType = allFilterName !== '' ? allFilterName : collection.list.replace(new RegExp('[0-9]', 'g'), '');
                pageurl.searchParams.set('l', listType);
                pageurl.searchParams.set('p', collection.currentPage);
                pageurl.searchParams.set('i', collection.itemsPerPage);
                if (collection.sectors.length > 0) pageurl.searchParams.set('s', collection.sectors.join('|'));
                else pageurl.searchParams.delete('s');
                if (collection.regions.length > 0) pageurl.searchParams.set('r', collection.regions.join('|'));
                else pageurl.searchParams.delete('r');
                if (collection.products.length > 0) pageurl.searchParams.set('a', collection.products.join('|'));
                else pageurl.searchParams.delete('a');
                if (collection.types.length > 0) pageurl.searchParams.set('t', collection.types.join('|'));
                else pageurl.searchParams.delete('t');
                if (collection.exclusions.length > 0) pageurl.searchParams.set('e', collection.exclusions);
                else pageurl.searchParams.delete('e');
                if (collection.category.length > 0) pageurl.searchParams.set('c', collection.category.join('|'));
                else pageurl.searchParams.delete('c');
                if (collection.subcategory.length > 0) pageurl.searchParams.set('sc', collection.subcategory.join('|'));
                else pageurl.searchParams.delete('sc');
                if (sr !== '') pageurl.searchParams.set('sr', sr);
                else pageurl.searchParams.delete('sr');
                if (collection.tags.length > 0) pageurl.searchParams.set('tag', collection.tags.join('|'));
                else pageurl.searchParams.delete('tag');
                if (collection.keywords.length > 0) pageurl.searchParams.set('k', collection.keywords.join('|'));
                else pageurl.searchParams.delete('k');
                if (collection.apacproducts.length > 0) pageurl.searchParams.set('ap', collection.apacproducts.join('|'));
                else pageurl.searchParams.delete('ap');
                if (collection.apactopics.length > 0) pageurl.searchParams.set('at', collection.apactopics.join('|'));
                else pageurl.searchParams.delete('at');
                if (collection.apacuserroles.length > 0) pageurl.searchParams.set('aur', collection.apacuserroles.join('|'));
                else pageurl.searchParams.delete('aur');
                if (collection.product.length > 0) pageurl.searchParams.set('pr', collection.product.join('|'));
                else pageurl.searchParams.delete('pr');
                if (collection.topics.length > 0) pageurl.searchParams.set('tp', collection.topics.join('|'));
                else pageurl.searchParams.delete('tp');
                window.history.pushState({}, '', pageurl);
            }
            isPop = false;
        };

        //resets the page value of a list's data collection so it can start on page 1 again
        var resetPaging = function (list) {
            var indx = collections.findIndex(x => x.list === list);
            collections[indx].currentPage = 0;
        };

        //add a value to a list collection
        var addToArray = function (list, arr, item) {
            //console.log('Add: ' + list + ', ' + arr + ', ' + item);
            var indx = collections.findIndex(x => x.list === list);
            collections[indx][arr].push(item);
        };

        //remove/clear a value from a list collection
        var removeFromArray = function (list, arr, item) {
            var indx = collections.findIndex(x => x.list === list);
            var newarr = collections[indx][arr].filter(value => value !== item);
            collections[indx][arr] = newarr;
        };

        //checks the "All xxxx" options in a drop down list
        var checkForAll = function (list, filter) {
            var indx = collections.findIndex(x => x.list === list);
            var arr = collections[indx][filter];
            var chk = document.querySelector('#globalItemsContainer' + list + ' .pseudoDdlOptions_Container--' + filter + ' input[type=checkbox]');
            if (!chk) return;
            if (arr.length === 0) chk.checked = true;
            else chk.checked = false;
        };

        //resets an list collection array
        var clearArray = function (list, arr) {
            var indx = collections.findIndex(x => x.list === list);
            collections[indx][arr] = [];
        };

        //updates a drop down list when "All xxxx" is clicked
        var clearNonAllOptions = function (list, filter) {
            var filters = document.querySelectorAll('#globalItemsContainer' + list + ' .pseudoDdlOptions_Container--' + filter + ' input[type=checkbox]');
            for (var i = 0; i < filters.length; i++) {
                if (filters[i].dataset.filtervalue !== 'all') {
                    filters[i].checked = false;
                }
            }
        };

        //updates the text of the selected filters area when a drop down value has been selected
        var updateFiltersSelected = function (list) {
            var indx = collections.findIndex(x => x.list === list);
            var tempArray = [].concat(collections[indx].sectors, collections[indx].regions, collections[indx].products, collections[indx].types, collections[indx].apacproducts, collections[indx].product, collections[indx].apactopics, collections[indx].apacuserroles, collections[indx].topics);
            var filtersSelected = document.querySelector('#globalItemsContainer' + list + ' .pseudoDdlOptions_Container_selected');
            //if (list.startsWith('All')) {
                //return;
                //filtersSelected = document.querySelector('#globalItemsContainer' + list + ' .pseudoDdl.pseudoDdl--open');
                //if (!filtersSelected) return;
                //var options = filtersSelected.parentNode.querySelector('.pseudoDdlOptions_Container .col[data-list="All"]');
                //var indxName = '';
                //if (options) indxName = options.dataset.filtertype;
                //tempArray = indxName !== '' ? collections[indx][indxName] : collections[indx].sectors.concat(collections[indx].regions, collections[indx].products, collections[indx].types, collections[indx].apacproducts, collections[indx].apactopics, collections[indx].apacuserroles);
            //}
            if (!filtersSelected) return;
            var defaultText = list.startsWith('All') ? 'No filters selected' : 'Select...';
            //for (var l = 0; l < tempArray.length; l++) {
            //    tempArray[l] = tempArray[l].join(' | ');
            //}
            var selectedValue = tempArray.join(' | ');
            filtersSelected.innerHTML = selectedValue;
            var ddl = document.getElementById('ddlFilter' + list);
            if (!ddl) ddl = filtersSelected;
            if (filtersSelected.innerHTML === '' || filtersSelected.innerHTML === '' || filtersSelected.innerHTML.replace(/| /g,'') === ' ') {
                filtersSelected.innerHTML = 'No filters selected';
                filtersSelected.style.textTransform = "none";
                ddl.innerHTML = defaultText;
                //pseudoDdl.innerHTML = 'Click to select';
            } else {
                filtersSelected.style.textTransform = "capitalize";
                ddl.innerHTML = selectedValue;
                //pseudoDdl.innerHTML = 'Click to change';
            }
        };

        //get ready to reload a list - ignores "All" lists like drop down collections or search boxes
        var setUpReload = function (list, ignorePopUpdate) {
            if (list.startsWith('All')) return;
            document.querySelector('#globalItemsContainer' + list + ' .filterable-list').classList.remove('show');
            setTimeout(function () { gbg.GlobalItemsList.loadContent(list, true, 1, ignorePopUpdate); }, 500);
        };

        //load more content for a selected list
        function loadMoreContent(list, type) {
            var indx = collections.findIndex(x => x.list === list);
            //collections[indx].currentPage += 1;
            //collections[indx].types = [type];
            gbg.GlobalItemsList.loadContent(list, false);

        }

        //not used - didn't work, so coded similarly above where needed
        var debounce = function (fn, delay) {
            var timer = null;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    fn.apply(context, args);
                }, delay);
            };
        };

        //bring the first list into view when a search box is updated and enter pressed or the form is submitted
        var scrollToFirstList = function () {
            if (globalItemsContainers.length > 0) {
                globalItemsContainers[0].scrollIntoView({ behavior: 'smooth' });
            }
        };

        //logs the search box value in GA
        var searchEvent = function (glbl) {
            var gcat = 'search';
            var gact = 'keyword';
            if (typeof ga === 'function') {
                var command = '';

                try {
                    if (typeof google_tag_manager !== 'undefined')
                        command = ga.getAll()[0].get('name') + '.';

                    command += 'send';

                    ga(command, 'event', {
                        'eventCategory': gcat,
                        'eventAction': gact,
                        'eventLabel': glbl
                    });
                }
                catch (e) {
                    try {
                        ga('send', 'event', {
                            'eventCategory': gcat,
                            'eventAction': gact,
                            'eventLabel': glbl
                        });
                    }
                    catch (e) {
                        //nothing
                    }
                }
            }
        };

        var findParentForm = function (elem) {
            for (; elem && elem !== document; elem = elem.parentNode) {
                if (elem.nodeName === 'FORM') return elem;
            }
            return null;
        };

        return {
            init: init,
            checkUrlPresets: checkUrlPresets,
            popstateReload: popstateReload,
            resetPaging: resetPaging,
            clearArray: clearArray,
            clearNonAllOptions: clearNonAllOptions,
            addToArray: addToArray,
            removeFromArray: removeFromArray,
            checkForAll: checkForAll,
            setUpReload: setUpReload,
            loadMoreContent: loadMoreContent,
            loadContent: loadContent,
            updateFiltersSelected: updateFiltersSelected,
            filterListClick: filterListClick,
            debounce: debounce,
            scrollToFirstList: scrollToFirstList,
            searchEvent: searchEvent
        };
    }());

}());

document.addEventListener('readystatechange', event => {

    
     
    

    // When window loaded ( external resources are loaded too- `css`,`src`, etc...) 
    if (event.target.readyState === "complete") {
        gbg.GlobalItemsList.init();
    }

});

var searchBoxTimer = null;
var searchValue = '';
//var popped = ('state' in window.history && window.history.state !== null), initialURL = location.href;
